import type { UndecoratedProduct } from '@witmetrics/utils';
import { sortByKey } from '@witmetrics/utils/arrays';
import { parseLocaleNumber } from '@witmetrics/utils/numbers';
import { buildProductOption } from '@witmetrics/unison-core';
import { API } from '@/api';

export const classes = {
  dialog: 'w-[98vw] max-w-[550px] min-w-[400px]',
  body: 'w-full max-h-[80vh] min-h-[100px] pt-2 pb-12 overflow-auto',
  input: 'w-full mb-3 mx-0',
  comments: 'w-full mt-6 mb-3 mx-0',
};

export async function fetchLabProducts(labId: number) {
  return (
    await API.Labs.fetchLabProducts(labId, {
      filters: [],
      pagination: { page: 1, pageSize: 250 },
    })
  ).results;
}

export function createNewOrderProduct(
  orderId: number,
  productId: number,
  price: string,
  comments: string
) {
  return API.Orders.createNewOrderProduct(orderId, {
    productId,
    price: parseLocaleNumber(price).toString(),
    comments,
  });
}

export function updateOrderProduct(
  orderProductId: number,
  productId: number,
  price: string,
  comments: string
) {
  return API.Orders.updateOrderProduct(orderProductId, {
    productId,
    price: parseLocaleNumber(price).toString(),
    comments,
  });
}

export function sortProducts(products: UndecoratedProduct[]) {
  return sortByKey(products.map(buildProductOption), 'label', -1);
}
